import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 26 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.08em]">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Chapter = ({ num, label, dark = false }) => (
  <Reveal>
    <div className="mb-5 flex items-center gap-4" data-testid={`chapter-${num}`}>
      <span className="font-serif text-lg italic text-gold">{num}</span>
      <span className="hairline w-10" />
      <span
        className={`text-xs font-bold uppercase tracking-[0.25em] ${
          dark ? "text-gold-soft" : "text-gold"
        }`}
      >
        {label}
      </span>
    </div>
  </Reveal>
);

export const SectionTitle = ({ children, dark = false, className = "" }) => (
  <Reveal delay={0.05}>
    <h2
      className={`font-serif text-3xl leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl ${
        dark ? "text-ivory" : "text-navy"
      } ${className}`}
    >
      {children}
    </h2>
  </Reveal>
);

export const GoldButton = ({ children, onClick, testid, className = "" }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className={`group inline-flex w-full items-center justify-center gap-2 rounded-full bg-navy px-7 py-4 text-sm font-bold uppercase tracking-[0.14em] text-ivory shadow-[0_10px_30px_-10px_rgba(27,42,74,0.5)] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-navy-deep hover:shadow-[0_18px_36px_-12px_rgba(27,42,74,0.55)] active:translate-y-0 sm:w-auto ${className}`}
  >
    {children}
  </button>
);

export const WaButton = ({ children, href, testid, className = "" }) => (
  <a
    data-testid={testid}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex w-full items-center justify-center gap-2 rounded-full bg-wa px-7 py-4 text-sm font-bold uppercase tracking-[0.14em] text-[#063A2C] shadow-[0_10px_30px_-10px_rgba(18,140,126,0.5)] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-wa-dark hover:text-white active:translate-y-0 sm:w-auto ${className}`}
  >
    {children}
  </a>
);
